export default {
  common: {
    modalBtnConfirm: "Confirm",
    modalBtnCancel: "Cancel",
    unknownError: "Unknown Error",
    loginExpired: "Login has expired, please log in again",
    placeholderDefaultSelectText: "Please Select",
    paginationTotal: "{x} In total",
    loading: "Loading...",
    refresh: "Refresh",
    close: "Close",
    back: "Back",
    gotIt: "Got it",
    copy: "Copy",
    copied: "Copied",
    search: "Search",
    sort: "Sort",
    clearGate: "Clear gate",
    actions: {
      viewDetail: "View Detail",
      viewPlan: "View Plan",
      editGate: "Edit Gate",
      archive: "Archive",
      markAsReleased: "Mark as released",
      applyToTripList: "Apply to trip list",
      uploadPlanData: "Upload plan data",
      startCalculating: "Start calculating",
      calculating: "Calculating",
      start_calculation: "Start calculation",
      cancel_calculation: "Cancel calculation",
      continue: "Continue",
      save: "Save",
      saveAsNew: "Save as a new scenario",
      runSimulator: "Run simulator",
      start: "Start",
      pause: "Pause",
      preview: "Preview",
      browseFiles: "Browse files",
      addNewGate: "Add new gate",
      update: "Update",
      signOut: "Sign Out",
      goToHomePage: "Go to home page",
    },
    table: {
      number: "No.",
      gateNumber: "Gate Number",
      gateNo: "Gate No.",
      shortR08: "Short R08",
      detail: "Detail",
      action: "Action",
      select: "Select",
      departureTime: "Departure Time",
      routeSchedule: "Route Schedule",
      tripSequence: "Trip Sequence",
      maxVolume: "Max Volume",
      status: "Status",
      orderNumber: "Order No.",
      article: "Article",
      chunk: "Chunk",
      orderStatus: "Order Status",
      rpaStatus: "RPA Status",
      stackPlan: "Stack Plan",
      updateTime: "Update Time",
      releasedTotal: "Released/Total",
      doneTotal: "Done/Total",
      tripStatus: "Trip Status",
      version: "Version",
      uploadTime: "Upload Time",
      fullPallets: "Full Pallets",
      pickingPallets: "Picking Pallets",
      calculationStatus: "Calculation Status",
      fillingRate: "Filling Rate",
      scenarioName: "Scenario Name",
      plannedVolume: "Planned Volume",
      simulationDetail: "Simulation Detail",
      finishedTime: "Finished Time",
      lut: "LUT",
      simulatedFr: "Simulated FR",
      loadingInstruction: "Loading Instruction",
      restedPallets: "Rested Pallets",
      bufferedPallets: "Buffered Pallets",
      simulationTime: "Simulation Time",
      checksum: "Checksum",
      stagingEntrance: "Staging Entrance",
      used: "Used",
    },
  },
  validation: {
    required: "Required",
    nonNegativeNumber: "Please enter a non-negative number",
    nonNegativeNumberInM: "Please enter a non-negative number in m",
    nonNegativeIntegerInMm: "Please enter a non-negative integer in mm",
    outOfReasonableRange: "Parameter out of reasonable range",
  },
  tripStatus: {
    FINISHED: "Finished",
    TO_RELEASE: "To release",
    RELEASING: "Releasing",
    RUNNING: "Running",
    PAUSED: "Paused",
    PLACED: "Placed",
    DONE: "Done",
    READY: "Ready",
  },
  sideMenu: {
    planningPage: "Planning",
    tripListPage: "Trip List",
    gateListPage: "Gate List",
    historyPage: "History",
    configuration: "Configuration",
    dashboardPage: "Dashboard",
  },
  homePage: {
    welcome: "Welcome to Loading Master",
    title: "Control Panel",
    selectDc: "Select your DC",
    dcCode: "DC code",
  },
  siteHomePage: {
    greeting: "Hi {name}, Welcome to Control Panel",
    greetingWithoutName: "Hi, Welcome to Control Panel",
    tagline: "A better flow for a better warehouse",
    performanceDashboard: "Performance Dashboard",
    planningSimulation: "Planning Simulation",
    gateAssignment: "Gate Assignment",
    tripRelease: "Trip Release",
    configuration: "Configuration",
    simulator: "Simulator",
  },
  appHeader: {
    productName: "Loading Master",
    openProfileSheet: "Open profile sheet",
  },
  dashboardPage: {
    title: "Performance Dashboard",
    selectDateRange: "Select date range",
    trips: "Trips",
    actualFrUpdate: {
      addActualFr: "Add Actual FR",
      editActualFr: "Edit Actual FR",
      tripInfo: "Trip info",
      actualFrCalculation: "Actual FR calculation",
      add: "Add",
      update: "Update",
    },
    chart: {
      fillingRate: "Filling Rate",
      stagingAndLoadingDuration: "Staging & Loading Duration",
      simulatedFr: "Simulated FR",
      actualFr: "Actual FR",
      unitPlannedFr: "Unit planned FR",
    },
    metric: {
      trips: "Trips",
      calculationTime: "Calculation Time",
      completedTripsCount: "Count of completed trips",
      actualFillingRate: "Actual Filling Rate",
      averageActualFillingRate: "Average actual filling rate",
      stagingDuration: "Staging Duration",
      averageStagingDuration: "Average staging duration",
      loadingDuration: "Loading Duration",
      averageLoadingDuration: "Average loading duration",
      missingAcutalFillingRateTooltip:
        "Add the calculated volume from Astro for the missing trip to complete the metric.",
    },
  },
  gateAssignment: {
    title: "Gate Assignment",
    history: {
      title: "Gate Assignment History",
      tooltip: "History",
      goBack: "Go back",
      goToPage: "Go to history page",
    },
    selectGate: "Select gate",
    stackPlanNoticeModalTitle: "Important Notice",
    stackPlanNoticeModalContent:
      "Stack plan viewing is unavailable until orders are released in Astro. Release the trip orders, then begin staging and view the stack plan.",
    changedOrderModalTitle: "Order changed",
    affectedChunk: "Affected Chunk {chunk}",
    tripDetail: {
      searchArticle: "Search article",
      searchPlaceholder: "Search",
    },
  },
  tripListPage: {
    title: "Trip Release",
    history: {
      title: "Trip History",
      tooltip: "Trip History",
      closeButton: "Close",
    },
    statusAll: "All status",
    inputSelectPlaceholder: "Choose",
    btnChooseArea: "Choose Area",
    tripsWaitingForGateAssignment:
      "{count} trip is waiting for selecting gates. | {count} trips are waiting for selecting gates.",
    modalChooseArea: {
      title: "Choose Area",
    },
    modalEditGate: {
      title: "Edit Gate",
      btnConfirm: "Update",
    },
    tripDetailModal: {
      statusFilterTitle: "Filter status",
      statusFilterClear: "Clear",
      orderStatusReferenceNotice:
        "Order status displayed on this page is for reference only. Astro determines the real order status.",
      inlineMessageWarningLabel: "warning",
    },
    startWarningText: "Selected items contain statuses other than 【TO_RELEASE】 or 【PAUSED】",
    pauseWarningText: "Selected items contain statuses other than 【RUNNING】",
    emptyTripWarningText: "Invalid Trip status",
    archiveConfirmTitle: "Confirm archiving selected trips?",
    archiveConfirmContent: "Once archived, no further actions will be available.",
    archiveConfirmBtnText: "Confirm",
    archiveCancelBtnText: "Back",
    orderChangedChunk: "Affected Chunk {chunk}",
  },
  planningPage: {
    title: "Planning Simulation",
    uploadPlanDataTitle: "Upload plan data",
    tripInfo: "Trip info",
    shortR08Placeholder: "e.g.4433226",
    shipmentId: "Shipment ID",
    shipmentIdPlaceholder: "e.g. 258-DT-S10000120227",
    loadingUnitType: "Loading Unit Type",
    selectLut: "Select LUT",
    uploadDataFile: "Upload data file",
    downloadDataTemplate: "Download data template",
    dragAndDropFilesToUploadOr: "Drag and drop files to upload or",
    browseFiles: "Browse files",
    uploaded: "Uploaded",
    uploadFailed: "Upload failed",
    uploadFailedTemplateHelp: "You can download data template",
    uploadFailedTemplateLink: "here",
    applySelectWarning: "Please select at least one planning trip to apply",
    applyPartialFailedTitle: "Some trips were not applied successfully",
    applyPartialFailedContent:
      "Chosen trips applied to trip list except the following trips:\n{items}",
    failedTripItem: "Short R08: {shortR08}, Version: V{version}",
    applySuccess: "Successfully applied to trip list",
    pickingPalletsNotUploadedTitle:
      "The Picking pallet data has not been uploaded yet. Still continue to start?",
    pickingPalletsNotUploadedContent:
      "The Picking pallet data has not been uploaded yet. Please upload it if needed. If not, you may start the calculation.",
    startCalculatingConfirm: "Start to calculating",
    backToUpload: "Back to Upload",
    cancelCalculationTitle: "Cancel this calculation?",
    cancelCalculationContent: "Once cancelled, the calculation cannot be restarted.",
    cancelCalculationNotYet: "Not yet",
    cancelCalculationConfirm: "Confirm cancellation",
    templateDownloadError: "Something went wrong",
    missingFiles: "Please upload at least one file",
    orderChangeSheetTitle: "Order change",
    orderChangeOverview: "Order change overview",
    orderDiffAdded: "Added",
    orderDiffRemoved: "Removed",
    orderDiffUnchanged: "Unchanged",
    orderDiffTotal: "Total",
    orderChangeDetails: "Order change details",
    orderDiffOrderNumber: "Order Number",
    orderDiffArticleNumber: "Article Number",
    orderDiffOrderType: "Order Type",
    orderDiffOrderChange: "Order Change",
    orderDiffNotice:
      "The plan data file has been updated. The following order changes have been made compared with the previous version. Please check before confirming.",
    viewOrderChange: "View order change",
  },
  parameters: {
    stagingAreaSize: "Staging area size",
    stagingParameters: "Staging parameters",
    loadingParameters: "Loading parameters",
    areaLength: "Length of staging area",
    areaWidth: "Width of staging area",
    stagingMaxHeight: "Maximum height for stacking in staging area",
    forkliftLaneWidth: "Minimum aisle width for forklift operation",
    stackExceedLength: "Overhanging length of upper pallet for stacking in staging area",
    forkExtendLength: "Maximum reach extension for forks/telehandler",
    upperLength: "Minimum clearance between unit Loads and the ceiling structure",
    mustLoadedLengthwiseLength: "Minimum Length of pallet must be loaded lengthwise",
    lastRowLength: "Minimum length of last row (chunk)",
    exceedLength: "Overhanging length of upper pallet",
    algorithmConfiguration: "Algorithm Configuration",
  },
  configurationPage: {
    title: "Configuration",
    tabsLabel: "Select settings",
    lutSettings: "LUT settings",
    gateSettings: "Gate settings",
    loadingUnitType: "Loading Unit Type",
    updateChangesTitle: "Update your changes?",
    updateChangesConfirm: "Update",
    discardAndContinue: "Discard and continue",
    updateChangesDescription: "You have unsaved changes, it will be lost if you you don’t.",
    updateSuccess: "Successfully update your preference",
  },
  gateSettingsPage: {
    basicInformation: "Basic information",
    addNewGate: "Add new gate",
    editGate: "Edit gate",
    confirmToAdd: "Confirm to add",
    save: "Save",
    gateNo: "Gate No.",
    checksum: "Checksum",
    stagingEntrance: "Staging entrance",
    selectEntrance: "Select entrance",
    entrance: {
      LEFT: "Left",
      RIGHT: "Right",
      BOTH: "Both sides",
    },
    action: "Action",
    ariaEditGate: "Edit gate",
  },
  simulatorPage: {
    title: "Simulator",
    requestTimedOut: "Request timed out",
    somethingWentWrong: "Something went wrong",
    uploadPlanData: "Upload plan data",
    dragAndDropSingleFile: "Drag and drop file here, or click to upload.",
    uploadPlanDataFile: "Upload plan data file",
    removeUploadedFile: "Remove uploaded file",
    simulationResult: "Simulation result",
    viewDetail: "View detail",
    description: "Description",
    simulationDetail: "Simulation detail",
    viewPdf: "View PDF",
    back: "Back",
  },
  scenario: {
    selectScenario: "Select a scenario",
    scenario: "Scenario",
    selectScenarioHint: "Select a scenario",
    createNew: "Create a new scenario",
    configuration: "Scenario configuration",
    copyAndSaveAsNew: "Copy and save as new",
    selectLoadingUnitType: "Select Loading Unit Type",
    editLoadingUnitType: "Edit Loading Unit Type",
    selectLut: "Select LUT",
    lut: "LUT",
    name: "Name",
    namePlaceholder: "E.g. Scenario A",
    description: "Description",
    descriptionPlaceholder: "Describe the scenario",
    saveAsNewTitle: "Save as a new scenario",
    continue: "Continue",
    save: "Save",
    createdSuccess: "{name} created successfully!",
    failedToCreate: "Failed to create scenario",
    createError: "An error occurred while creating the scenario",
    savedSuccess: "{name} saved successfully!",
    failedToSave: "Failed to save scenario",
  },
  logoutPage: {
    loggedOut: "You've been logged out successfully.",
  },
  notFoundPage: {
    title: "404 - Page not found",
    description:
      "The page you are looking for might have been removed or is temporarily unavailable.",
  },
};
